import React, { useState, useEffect } from "react";
import "../../Styles/Modal.css";
import { getData, clearAllData } from "../../utils/store-data";
import { USER_ID } from "../../utils/store-data-constants";
import {
  disable_user_account,
  update_profile_active,
} from "../../api/serverWrapper";
import { useNavigate } from "react-router-dom";

function DisableAccountModal({ isOpen, onClose, isProfile }) {
  const navigate = useNavigate();

  console.log(isProfile);

  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setSuccessMsg(false);
      setErrorMsg("");
      setIsLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleDisableAccount = async () => {
    try {
      setIsLoading(true);
      setErrorMsg("");

      const UserId = await getData(USER_ID);

      const resp = await disable_user_account({
        UserId,
      });

      console.log("Disable Account Response:", resp);

      if (resp?.code === 200) {
        setSuccessMsg(true);

        if(isProfile){
          updateProfile();
        }

        setTimeout(async () => {
          await clearAllData();
          navigate("/home");
        }, 2000);
      } else {
        setErrorMsg(
          resp?.data?.message || "Failed to disable account. Please try again.",
        );
      }
    } catch (error) {
      console.log(error);

      setErrorMsg(
        error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const updateProfile = async () => {
    try {
      const data = {
        ProfileId: isProfile,
        IsActive: 0, // TOGGLE
      };

      const resp = await update_profile_active(data);

      // Handle response if needed
      console.log(resp);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="confirm-modal">
        {successMsg ? (
          <>
            <h2>Account Disabled</h2>

            <p>
              Your account has been disabled successfully.
              <br />
              Redirecting to home page...
            </p>
          </>
        ) : (
          <>
            <button
              className="modal-close-btn"
              onClick={onClose}
              disabled={isLoading}
            >
              ✕
            </button>

            <h2>Confirm Disable Account</h2>

            <p>
              Your account will be temporarily disabled. You can reactivate it
              later by contacting support.
            </p>

            {errorMsg && (
              <div
                style={{
                  color: "red",
                  marginBottom: "15px",
                  textAlign: "center",
                }}
              >
                {errorMsg}
              </div>
            )}

            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={handleDisableAccount}
                disabled={isLoading}
              >
                {isLoading ? "Disabling..." : "Confirm"}
              </button>

              <button
                className="cancel-btn"
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DisableAccountModal;
